import React, { useRef, useState, useEffect } from 'react';
import Button from '../../components/Button';
import './Dropzone.css';

const Dropzone = ({ onUpload, message, types, clean, onRemove }) => {
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);

    const preventDefault = (e) => {
        e.preventDefault();
        // e.stopPropagation();
    }

    const fileDrop = (e) => {
        preventDefault(e);
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFile(files[0]);
        }
    }

    const fileSelected = (e) => {
        if (fileInputRef.current.files.length) {
            handleFile(fileInputRef.current.files[0]);
        }
        e.target.value = null;
    }

    const fileInputClicked = () => {
        fileInputRef.current.click();
    }

    const fileUploadClicked = () => {
        if (!selectedFile['invalid']) {
            onUpload(selectedFile);
        }
    }

    const handleFile = (file) => {
        setSelectedFile(file);
        if (!validateFile(file)) {
            file['invalid'] = true;
        }
    }

    const validateFile = (file) => {
        const validTypes = types;
        if (validTypes.indexOf(file.type) === -1) {
            return false;
        }

        return true;
    }

    const fileSize = (size) => {
        if (size === 0) {
          return '0 Bytes';
        }
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
    
    const fileType = (fileName) => {
        return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
    }

    const removeFile = () => {
        setSelectedFile(null);

        if(onRemove != undefined){
            onRemove()
        }
    }

    useEffect(() => {
        if(clean != undefined){
            if (clean == true){
                setSelectedFile(null);
            }
        }
    }, [clean])

    return (
        <div className="dropzone-container">
            <div className="drop-container"
                onDragOver={(e) => { preventDefault(e) }}
                onDragEnter={(e) => { preventDefault(e) }}
                onDragLeave={(e) => { preventDefault(e) }}
                onDrop={fileDrop}
                onClick={fileInputClicked}
            >
                <div className="drop-message">
                    <div className="upload-icon"><i className="ms-Icon ms-Icon--Upload"></i></div>
                    {message != null ? message : 'Arraste o arquivo Excel aqui, ou clique para selecionar o arquivo.'}
                </div>
                <input
                    ref={fileInputRef}
                    className="file-input"
                    type="file"
                    onChange={e => fileSelected(e)}
                />
            </div>
            <div className="file-display-container">
                {selectedFile ? 
                <div className="file-container">
                    <div>
                        <span className={`file-name ${selectedFile.invalid ? 'file-error' : ''}`}>{selectedFile.name}</span>
                        <div>
                        <span className="file-size">({fileSize(selectedFile.size)})</span> 
                        {selectedFile.invalid && <span className='file-error-message'>(Formato de arquivo inválido: {fileType(selectedFile.name)})</span>
                        }
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <Button disabled={selectedFile.invalid} text="Abrir" onClick={fileUploadClicked} style={{marginRight: '10px'}} color={"#4466F2"} hoverColor={"#434FB6"} />
                        <Button text="Remover" onClick={() => removeFile(selectedFile.name)} color={"#DC3545"}  hoverColor={"#750b1c"} />
                    </div>
                </div>
                : ''}
            </div>
        </div>
    );
}

export default Dropzone;
